/** @jsxImportSource @emotion/react */

import { IconButton, IconWrapper } from './styles';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';
import { useEffect, useState } from 'react';

import { PenTool as PenToolIcon } from 'lucide-react';
import UDTippy from 'ud-ui/components/tippy';
import lineDrawer from 'ud-ui/components/fabric-canvas/addons/line-drawer';
import { useSelector } from 'react-redux';

export function PenTool() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isSelected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    const unsubscribe = lineDrawer.drawMode.subscribe((value) => {
      setSelected(value);
    });
    return () => unsubscribe();
  }, []);

  const onClickPen = () => {
    if (!fabricManager) return;
    if (isSelected) {
      setSelected(false);
      lineDrawer.edit();
      return;
    }

    setSelected(true);
    lineDrawer.draw();
  };

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Перо'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <IconButton style={{ color: isSelected ? '#D9B244' : undefined }} onClick={onClickPen} tabIndex={0}>
          <IconWrapper icon={<PenToolIcon size={20} strokeWidth={1.5} />} />
        </IconButton>
      </span>
    </UDTippy>
  );
}
